import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {Switch,Route, RouteComponentProps} from 'react-router-dom';
import { DuelSummary } from './DuelSummary';
import { DuelList } from './DuelList';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container:{
      padding: theme.spacing(3)
    }
  }),
);
interface Props{
  
}

const DuelContainer: React.FC<Props> = (props) => {

    const classes = useStyles();

    return (
      <Box className={classes.container}>
        <Switch>
          <Route exact path={"/duel"} component={DuelList} />
          <Route path={"/duel/:id"} component={DuelSummary} />
        </Switch>
      </Box>
    )
}

export {DuelContainer} 